module.exports = __webpack_public_path__ + "static/media/protocogotas_preview.ba5d0042.png";